var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "attach_file"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_136_6368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_136_6368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "attach_file_2",
    d: "M8.625 17C7.475 17 6.5 16.6 5.7 15.8C4.9 15 4.5 14.025 4.5 12.875V5C4.5 4.175 4.79375 3.46875 5.38125 2.88125C5.96875 2.29375 6.675 2 7.5 2C8.325 2 9.03125 2.29375 9.61875 2.88125C10.2063 3.46875 10.5 4.175 10.5 5V12.125C10.5 12.65 10.3187 13.0938 9.95625 13.4563C9.59375 13.8188 9.15 14 8.625 14C8.1 14 7.65625 13.8188 7.29375 13.4563C6.93125 13.0938 6.75 12.65 6.75 12.125V5H7.875V12.125C7.875 12.3375 7.94687 12.5156 8.09062 12.6594C8.23438 12.8031 8.4125 12.875 8.625 12.875C8.8375 12.875 9.01562 12.8031 9.15938 12.6594C9.30312 12.5156 9.375 12.3375 9.375 12.125V5C9.375 4.475 9.19375 4.03125 8.83125 3.66875C8.46875 3.30625 8.025 3.125 7.5 3.125C6.975 3.125 6.53125 3.30625 6.16875 3.66875C5.80625 4.03125 5.625 4.475 5.625 5V12.875C5.625 13.7 5.91875 14.4063 6.50625 14.9938C7.09375 15.5813 7.8 15.875 8.625 15.875C9.45 15.875 10.1562 15.5813 10.7437 14.9938C11.3312 14.4063 11.625 13.7 11.625 12.875V5H12.75V12.875C12.75 14.025 12.35 15 11.55 15.8C10.75 16.6 9.775 17 8.625 17Z",
    fill: "url(#paint0_linear_136_6368)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_6368",
    x1: 8.625,
    y1: 2,
    x2: 8.625,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attachFile.223aadfea8f53835b74b0d342276093d.svg";
export { ForwardRef as ReactComponent };